import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "au-glow-btn__icon" }
const _hoisted_2 = { class: "au-glow-btn__content" }
const _hoisted_3 = { class: "au-glow-btn__label" }
const _hoisted_4 = { class: "au-glow-btn__desc" }

import { computed } from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'glow-button',
  props: {
    fullWidth: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
        fullWidth?: boolean,
    }

    

    const btnStyle = computed(() => {
        if (props.fullWidth){
            return {
                display: 'flex',
                width: '100%'
            }
        }
        return {};
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _mergeProps(_ctx.$attrs, {
    class: "au-glow-btn",
    style: _unref(btnStyle)
  }), [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "icon")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "label")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "description")
      ])
    ])
  ], 16))
}
}

})